import { LocationType } from '@/app/(dashboard)/projects/FolderSelectionTree'
import { Step1 } from '@/app/(dashboard)/upload/step1/Step1'
import { Step2 } from '@/app/(dashboard)/upload/step2/Step2'
import { Step3 } from '@/app/(dashboard)/upload/step3/Step3'
import { useUploadCrunch } from '@/app/(dashboard)/upload/UploadCrunchProvider'
import { BaseDialog, useFSTrackEvent } from '@/dc-shared-web/src'
import { useUploadDocument } from '@/dc-shared-web/src/hooks/api/document/useUploadDocument'
import {
  UploadDocumentParams,
  UploadDocumentResponse,
} from '@/dc-shared-web/src/hooks/api/document/uploadDocument'
import { FS, FS_CATEGORY } from '@/dc-shared-web/src/lib/trackingConstants'
import { FC } from 'react'
import { useGetErrorMessage } from '@/app/(dashboard)/hooks/useGetErrorMessage'

interface UploadCrunchModalProps {
  onClose: () => void
  crunchInitialLocation: LocationType
  teamUuid: string
}

export const UploadCrunchModal: FC<UploadCrunchModalProps> = ({
  onClose,
  crunchInitialLocation,
  teamUuid,
}) => {
  const { trackEvent } = useFSTrackEvent()
  const { currentStep } = useUploadCrunch()
  const {
    mutateAsync: uploadDocument,
    isLoading: isUploading,
    error,
  } = useUploadDocument()

  const handleUpload = async (
    uploadParams: UploadDocumentParams
  ): Promise<UploadDocumentResponse> => {
    return await uploadDocument(uploadParams)
  }

  const errorMessage = useGetErrorMessage(error)

  const handleClose = () => {
    if (!isUploading) {
      trackEvent(FS.BUTTON_CLICKED, {
        name: 'Close',
        page_category: FS_CATEGORY.UPLOAD,
      })
      onClose()
    }
  }

  return (
    <BaseDialog
      isOpen
      showCloseButton={!isUploading}
      onClose={handleClose}
      title='New Crunch'
      size='large'
      disableOutsideClick
      disableEscapeClose
      /* Actions are added by each step component. */
      primaryActionSlot={<></>}
      secondaryActionSlot={<></>}
    >
      {currentStep === 1 && (
        <Step1
          onCancel={onClose}
          disableLocationSelect={!teamUuid}
          crunchInitialLocation={crunchInitialLocation}
          teamUuid={teamUuid}
        />
      )}
      {currentStep === 2 && (
        <Step2
          teamUuid={teamUuid}
          onUpload={handleUpload}
          isUploading={isUploading}
          errorMessage={errorMessage}
        />
      )}
      {currentStep === 3 && <Step3 onClose={onClose} />}
    </BaseDialog>
  )
}
